
        function addBusinessDays(startDate, days) {
            var currentDate = startDate.clone();
            while (days > 0) {
                currentDate.addDays(1);
                if (currentDate.is().weekday()) {
                    days--;
                }
            }
            return currentDate;
        }

        var fromDate = addBusinessDays(Date.today(), 5);

        document.getElementById('deliverydate').innerHTML = `@media (max-width: 750px){
            .product-item__price_and_reviews_row:after {
                content: "Get it Before: ${fromDate.toString('MMM dd')}";
            }
        }`;
